import React, { useEffect } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { scrollModePlugin } from '@react-pdf-viewer/scroll-mode';
// Import only the core and default layout styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// For the scroll-mode plugin, we'll dynamically load the CSS

const ContractViewer = ({ pdfUrl, onClose }) => {
  // Since this is a mobile-first component, we'll use a constant instead of state
  
  
  // Hook for CSS imports and styling
  useEffect(() => {
    // Dynamically import the scroll-mode CSS
    
    const isMobilemy = window.innerWidth < 768;
    
    const mobileHeight = isMobilemy ?'350px' :'650px';
    const mobileWidth = isMobilemy ?'100%' :'80vw';
    const mobileBorderRadius = '10px';
    
    // Add custom CSS to style the PDF viewer container and its children
    const style = document.createElement('style');
    style.innerHTML = `
      .rounded-pdf-viewer {
        border-radius: ${mobileBorderRadius};
        overflow: hidden;
        width: ${mobileWidth};
        height: ${mobileHeight};
      }
      .rounded-pdf-viewer .rpv-core__viewer {
        border-radius: ${mobileBorderRadius};
        width: 100% !important;
      }
      .rounded-pdf-viewer .rpv-core__wrapper {
        border-radius: ${mobileBorderRadius};
        width: 100% !important;
      }
      .rounded-pdf-viewer .rpv-default-layout__container {
        border-radius: ${mobileBorderRadius};
        width: 100% !important;
      }
      .rounded-pdf-viewer .rpv-default-layout__main {
        border-radius: ${mobileBorderRadius};
        width: 100% !important;
      }
      .rounded-pdf-viewer .rpv-core__inner-container {
        width: 100% !important;
      }
      .rounded-pdf-viewer .rpv-core__viewer-zone {
        width: 100% !important;
      }
      /* Target PDF page container */
      .rounded-pdf-viewer .rpv-core__page-layer {
        width: 100% !important;
      }
      /* Target actual PDF pages */
      .rounded-pdf-viewer .rpv-core__canvas-layer {
        width: 100% !important;
      }
      /* Target the text layer */
      .rounded-pdf-viewer .rpv-core__text-layer {
        width: 100% !important;
      }
      
      /* Mobile-specific styles - always applied since this is a mobile-focused component */
      .rounded-pdf-viewer {
        max-width: 100vw !important;
        height: ${mobileHeight} !important;
        border-radius: ${mobileBorderRadius} !important;
      }
      
      /* Make toolbar more compact on mobile */
      .rounded-pdf-viewer .rpv-default-layout__toolbar {
        padding: 4px !important;
      }
      
      /* Make buttons smaller on mobile */
      .rounded-pdf-viewer .rpv-core__minimal-button {
        padding: 4px !important;
      }
      
      /* Adjust page size for mobile */
      .rounded-pdf-viewer .rpv-core__canvas-layer canvas {
        max-width: 100% !important;
        height: auto !important;
      }
    `;
    document.head.appendChild(style);
    
    // Cleanup function
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  
  // Create plugins with mobile-specific adjustments
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [defaultTabs[0]],
    toolbarPlugin: {
      fullScreenPlugin: {
        // Enable full screen mode
        enableShortcuts: true,
      },
    },
    // Ensure content fits width
    responsiveViewerPlugin: {
      responsiveMode: 'fitWidth',
    },
  });
  
  // Create the scroll mode plugin with error handling
  let scrollModePluginInstance;
  try {
    scrollModePluginInstance = scrollModePlugin();
  } catch (error) {
    console.warn('Could not initialize scroll-mode plugin:', error);
    scrollModePluginInstance = null;
  }
  
  const plugins = scrollModePluginInstance 
    ? [defaultLayoutPluginInstance, scrollModePluginInstance]
    : [defaultLayoutPluginInstance];
  
  const isMobile = window.innerWidth < 768;
  const initialScale = isMobile ? 0.6 : 1.5;

  const containerStyle = {
    position: 'fixed',
    // centred in the space UNDER the info bar on the phone layout (--fr-modal-top, 0 elsewhere)
    top: isMobile ? 'calc(var(--fr-modal-top, 0px) + (100dvh - var(--fr-modal-top, 0px) - 68px) / 2)' : '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: isMobile ? 'min(85vh, calc(100dvh - var(--fr-modal-top, 0px) - 92px))' : '95vh',   // 68 footer + 24 breathing
    width: isMobile ? '95vw' : '95vw',
    borderRadius: '10px',
    overflow: 'hidden',
    zIndex: 1000,
    background: '#1a1a1a',
  };
  
  return (
  <div style={containerStyle} className="contract-viewer-container rounded-pdf-viewer">
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 12px',
      background: '#777B7E',
    borderRadius: '10px 10px 0 0',
    position: 'relative',
    zIndex: 10,
  }}>
   

      <span style={{ color: '#fff', fontSize: '0.85rem', opacity: 0.85 }}>Document Viewer</span>
      <button
        onClick={onClose}
        style={{
          background: '#dc2626',
          border: '1px solid rgba(239,68,68,0.3',
          color: '#fff',
          borderRadius: '50%',
          width: '30px',
          height: '30px',
          fontSize: '16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        ✕
      </button>
    </div>
    <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.6.172/pdf.worker.min.js">
      <Viewer
        fileUrl={pdfUrl}
        plugins={plugins}
        defaultScale={initialScale}
        initialPage={0}
        renderLoader={(percentages) => (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div>Loading {Math.round(percentages)} %</div>
          </div>
        )}
        defaultViewMode="FitWidth"
      />
    </Worker>
  </div>
);
};

export default ContractViewer;